import React, { useState } from "react";
import Common_Report_Offcanvas from "../../../../common_report_offcanvas/Common_Report_Offcanvas";
import Intermediate_Check_Report_Filter from "./intermediate_check_report_filter/Intermediate_Check_Report_Filter";
import Intermediate_Check_Report_Table from "./intermediate_check_report_table/Intermediate_Check_Report_Table";


const Intermediate_Check_Report = () => {
  const [show, setShow] = useState(false);

  return (
    <section className="Sample_Report">
      <div className="Sample_Report_Filter_div">
        <Intermediate_Check_Report_Filter setShow={setShow} />
      </div>

      <div className="report_table_div">
        <Intermediate_Check_Report_Table />
      </div>

      <Common_Report_Offcanvas
        title={"Intermediate Check Report"}
        show={show}
        setShow={setShow}
        handleClose={() => {
          setShow(false);
        }}
      />
    </section>
  );
};

export default Intermediate_Check_Report;
